export default "__VITE_ASSET__CVsT$8ht__"